import React, { useState, Fragment } from 'react';
import { icons } from '../../../assets/icons';
import './index.scss';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { new_user_admin } from '../../../api/redux/slices/Admin';
import { useDispatch } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';
import { Modal, showToast } from '../../../components/modal';
import { ButtonComponent } from '../../../components/buttons';
import ShopFields from './ShopFields';

const AddUser = () => {
	const [isFocus, setIsFocus] = useState(false);
	const [shopToDeleteIndex, setShopToDeleteIndex] = useState(null);
	const [errorModal, setErrorModal] = useState({ errMsg: '', isShow: false });
	const [isLoading, setIsLoading] = useState(false);
	const [showDeleteModal, setShowDeleteModal] = useState(false);

	const dispatch = useDispatch();
	const navigate = useNavigate();
	const params = useParams();
	const token = localStorage.getItem('accesstoken');

	const { page } = useParams();

	const [values, setValues] = useState({
		first_name: '',
		last_name: '',
		is_client: true,
		email: '',
		phone: '',
		company_name: '',
		password: '',
		confirmPassword: '',
		tax_registration_number: '',
		customs_code: '',
		regulation: 'espece',
		categories: 'detaillant',
	});

	const [shopFields, setShopFields] = useState([
		{
			id: uuidv4(),
			name: '',
			address_number: '',
			street: '',
			ville: '',
			postal_code: '',
			country: '',
			region: '',
		},
	]);

	const addField = () => {
		setShopFields([
			...shopFields,
			{
				id: uuidv4(),
				name: '',
				address_number: '',
				street: '',
				ville: '',
				postal_code: '',
				country: '',
				region: '',
			},
		]);
	};

	const handleChangeShopForm = (id, e) => {
		let data = [...shopFields];
		const index = data.findIndex((item) => item.id === id);

		if (index !== -1) {
			e.target.name === 'postal_code'
				? (data[index][e.target.name] = e.target.value.replace(/\D/g, ''))
				: (data[index][e.target.name] = e.target.value);

			// Reset region if country is not Tunisia
			if (e.target.name === 'country' && e.target.value !== 'TUN') {
				data[index].region = '';
			}

			setShopFields(data);
		}
	};

	const handleDeleteAddedShop = (id) => {
		if (shopFields.length > 1) {
			setShopFields(shopFields.filter((field) => field.id !== id));
			setShowDeleteModal(false);
			setShopToDeleteIndex(null);
		}
	};

	const confirmDeleteShop = (id) => {
		setShopToDeleteIndex(id);
		setShowDeleteModal(true);
	};

	const handleAddClient = (e) => {
		e.preventDefault();

		let canAddUser = true;

		const trimmedShopFields = shopFields.map((item) => {
			const data = {
				name: item.name.trim(),
				address_number: item.address_number,
				street: item.street.trim(),
				ville: item.ville.trim(),
				postal_code: item.postal_code,
				country: item.country,
				region: item.region,
			};

			if (!data.name || !data.street || !data.ville || !data.postal_code || !data.country) {
				showToast('Veuillez remplir tous les champs du magasin', 'warn');
				canAddUser = false;
			}
			// Region only required for Tunisia
			if (data.country === 'TUN' && !data.region) {
				showToast('Veuillez sélectionner un gouvernorat', 'warn');
				canAddUser = false;
			}
			return data;
		});

		if (!canAddUser) return;

		// ✅ Matricule fiscal is required, customs_code is optional
		if (
			!values.first_name.trim() ||
			!values.last_name.trim() ||
			!values.email.trim() ||
			!values.phone.trim() ||
			!values.company_name.trim() ||
			!values.tax_registration_number.trim() || // ✅ Required
			!values.password ||
			!values.confirmPassword
		) {
			showToast('Veuillez remplir tous les champs obligatoires', 'warn');
			return;
		}

		if (values.password !== values.confirmPassword) {
			showToast('Mots de passe non identiques', 'warn');
			return;
		}

		const ClientData = {
			first_name: values.first_name.trim(),
			last_name: values.last_name.trim(),
			email: values.email.trim(),
			phone: values.phone.trim(),
			company_name: values.company_name.trim(),
			tax_registration_number: values.tax_registration_number.trim(), // ✅ Required
			customs_code: values.customs_code.trim() || undefined, // ✅ Optional
			is_client: true,
			password: values.password,
			confirmPassword: values.confirmPassword,
			regulation: values.regulation,
			categories: values.categories,
			shop: trimmedShopFields,
		};

		setIsLoading(true);

		dispatch(new_user_admin({ token: token, data: ClientData }))
			.unwrap()
			.then(() => {
				navigate(`/admin/users/${params?.page ?? 1}`);
			})
			.catch((err) => {
				setErrorModal({
					errMsg:
						err.response?.data?.message ||
						err.response?.data ||
						err ||
						'An error occurred',
					isShow: true,
				});
			})
			.finally(() => setIsLoading(false));
	};

	return (
		<div id='add-user_admin'>
			{errorModal.isShow && (
				<Modal errorModal={errorModal} setModalError={setErrorModal} />
			)}

			<form onSubmit={handleAddClient}>
				<div className='navbar' style={{ width: 'calc(100vw - 20rem)', marginBottom: '2rem' }}>
					<Link
						to={`/admin/users/${page}`}
						style={{ width: '500px', display: 'flex', alignItems: 'center' }}
					>
						<icons.BsArrowLeft style={{ color: '#5B5B5B', marginRight: '10px' }} />
						<h1>Liste des clients</h1>
					</Link>

					<div className='submit-btns'>
						<div className='add-btns'>
							<Link to={`/admin/users/${page}`}>
								<button className={isFocus ? 'button-nature' : 'button-nature-inactive'}>
									Annuler
								</button>
							</Link>

							<ButtonComponent
								name='Enregistrer'
								loading={isLoading}
								type='submit'
								className={isFocus ? 'button-primary' : 'button-primary-inactive'}
							/>
						</div>
					</div>
				</div>

				<Fragment>
					<div className='user-infos'>
						<h2>Type catégorie</h2>
						<div className='line'>
							<input type='radio' name='usercategory' defaultChecked onChange={() => setValues({ ...values, categories: 'detaillant' })} />
							<label>Détaillant</label>
						</div>
						<div className='line'>
							<input type='radio' name='usercategory' onChange={() => setValues({ ...values, categories: 'grossiste' })} />
							<label>Grossiste</label>
						</div>
						<div className='line'>
							<input type='radio' name='usercategory' onChange={() => setValues({ ...values, categories: 'monoprix' })} />
							<label>Grande surface</label>
						</div>
					</div>

					<div className='user-infos'>
						<h2>Type de règlement</h2>
						<div className='line'>
							<input type='radio' name='userreglement' defaultChecked onChange={() => setValues({ ...values, regulation: 'espece' })} />
							<label>Espèce</label>
						</div>
						<div className='line'>
							<input type='radio' name='userreglement' onChange={() => setValues({ ...values, regulation: 'traite' })} />
							<label>Traité</label>
						</div>
						<div className='line'>
							<input type='radio' name='userreglement' onChange={() => setValues({ ...values, regulation: 'cheque' })} />
							<label>Chèque</label>
						</div>
					</div>
				</Fragment>

				<div className='user-details'>
					<h2>Information générale</h2>

					<div className='form-line'>
						<div className='field'><label>Nom <span className="required">*</span></label><input type='text' value={values.first_name} onChange={(e) => { setValues({ ...values, first_name: e.target.value }); setIsFocus(true); }} required /></div>
						<div className='field'><label>Prénom <span className="required">*</span></label><input type='text' value={values.last_name} onChange={(e) => setValues({ ...values, last_name: e.target.value })} required /></div>
					</div>
					<div className='field'><label>Email <span className="required">*</span></label><input type='email' value={values.email} onChange={(e) => setValues({ ...values, email: e.target.value })} required /></div>
					<div className='field'><label>Téléphone <span className="required">*</span></label><input type='text' value={values.phone} onChange={(e) => setValues({ ...values, phone: e.target.value.replace(/[^0-9+\s]/g, '') })} required /></div>
					<div className='field'><label>Société <span className="required">*</span></label><input type='text' value={values.company_name} onChange={(e) => setValues({ ...values, company_name: e.target.value })} required /></div>
					
					{/* ✅ Matricule fiscal - REQUIRED */}
					<div className='field'>
						<label>Matricule fiscal <span className="required">*</span></label>
						<input 
							type='text' 
							value={values.tax_registration_number} 
							onChange={(e) => setValues({ ...values, tax_registration_number: e.target.value })} 
							required 
						/>
					</div>
					
					{/* ✅ Référence code client - OPTIONAL */}
					<div className='field'>
						<label>Référence code client <span style={{color: '#999', fontSize: '0.8rem'}}>(optionnel)</span></label>
						<input 
							type='text' 
							value={values.customs_code} 
							onChange={(e) => setValues({ ...values, customs_code: e.target.value })} 
						/>
					</div>
					
					<div className='field'><label>Mot de passe <span className="required">*</span></label><input type='password' value={values.password} onChange={(e) => setValues({ ...values, password: e.target.value.trim() })} required /></div>
					<div className='field'><label>Confirmer mot de passe <span className="required">*</span></label><input type='password' value={values.confirmPassword} onChange={(e) => setValues({ ...values, confirmPassword: e.target.value.trim() })} required /></div>
				</div>

				<ShopFields
					shopFields={shopFields}
					handleChangeShopForm={handleChangeShopForm}
					handleDeleteAddedShop={handleDeleteAddedShop}
					addField={addField}
					showDeleteModal={showDeleteModal}
					setShowDeleteModal={setShowDeleteModal}
					shopToDeleteIndex={shopToDeleteIndex}
					setShopToDeleteIndex={setShopToDeleteIndex}
					confirmDeleteShop={confirmDeleteShop}
				/>
			</form>
		</div>
	);
};

export default AddUser;